import IconFerry from "@Icons/transportType/IconFerry";
import IconType from "@/types/Icon.type";

function IconDeckPassengerClass(props: IconType) {
    return (
        <IconFerry
            {...props}
        />
    )
}

export default IconDeckPassengerClass